import React, { useEffect, useState } from "react";
import {
    Container,
    Typography,
    Box,
    TextField,
    Button,
    Paper,
    Tabs,
    Tab,
    Alert,
    Grid,
} from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate, useParams } from "react-router-dom";
import { PeriodoAcademico, VoidPeriodoAcademico } from "../../interfaces/SAAC/PeriodoAcademico";
import AcademicoService from "../../services/AcademicoService";
import AlertService from "../../services/AlertService";
import { useAppSelector } from "../../redux/hooks";
import AyudantiaService from "../../services/AyudantiaService";
import { AyudPeriodo, VoidAyudPeriodo } from "../../interfaces/AYUDANTIAS/AyudPeriodo";
import { format } from "date-fns";
import { es } from 'date-fns/locale';
import { EstudianteActivoT, VoidEstudianteActivo } from "../../interfaces/SAAC/EstudianteActivo";
import { EstudianteActivo } from "./EstudianteActivo";
import { SolicitarAyudForm } from "../Formularios/SolicitarAyudForm";
import { SolicitudAyudanteInv } from "../../interfaces/AYUDANTIAS/SolicitudAyud";
import { VoidAyudantiaInvestigacion } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { InformesInvestigador, InitialInformesInvestigador } from "../../interfaces/ITINERARIO/InformesInvestigador";
import { TablaInformePendiente } from "./TablaInformePendientes";
import ProyectoService from "../../services/ProyectoService";
import { AyudanteInvInfo } from "../../interfaces/AYUDANTIAS/AyudanteInvInfo";
import { useIsAuthenticated } from "@azure/msal-react";
import { BusqProyAyudantiasTable } from "./BusqProyAyudantiasTable";
import { DataSolicitudAyudantiasProy } from "../../interfaces/UTILS/DataBsqProy";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";
import { useProyecto } from "../../common/ProyectoProvider";



const academicoService = new AcademicoService();
const alertaService = new AlertService();
const ayudantiaService = new AyudantiaService();
const proyectoService = new ProyectoService();

export const AyudantiasInvestigacion: React.FC = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const navigate = useNavigate();
    //const { isAuth, userData } = useAppSelector((state) => state.authReducer);
    const isAuthenticated = useIsAuthenticated();
    const token = useAppSelector((state) => state.authReducer.token);
    const [periodoActivo, setPeriodoActivo] = useState<PeriodoAcademico>(VoidPeriodoAcademico());
    let [fechasAyu, setFechasAyu] = useState<AyudPeriodo>(VoidAyudPeriodo());
    const [estudianteValido, setEstudianteValido] = useState(false);
    let [estudiante, setEstudiante] = useState<EstudianteActivoT>(VoidEstudianteActivo());
    const [limpiar, setLimpiar] = useState(false);
    //const { idProy } = useParams();
    let [informes, setInformes] = useState<InformesInvestigador>(InitialInformesInvestigador());
    const [readySolicitudes, setReadySolicitudes] = useState(false);
    const [solicitudes, setSolicitudes] = useState<Array<AyudanteInvInfo>>([]);

    const [readyFechas, setReadyFechas] = useState(false);

    const [readyInformes, setReadyInformes] = useState(false);

    const handleSetReadySolicitudes = ()=>{
        setReadySolicitudes(false)
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
        limpiarForm();
    };

    const goToNavigation = (site: string) => {
        navigate(site);
    };

    const { idProy } = useProyecto();

    function DentroPeriodoAyudantias(): boolean {
        let bandera = false;
        const today = new Date();
        if (fechasAyu.estado === 1) {
          const fechaInicio = new Date(fechasAyu.fechaaperturaayudantias);
          const fechaFin = new Date(fechasAyu.fechacierreayudantias);
          fechaFin.setHours(23, 59, 59, 999);
          bandera = today >= fechaInicio && today <= fechaFin;
        }
        return bandera;
      }

    useEffect(() => {
        if (isAuthenticated && idProy) { // Asegurar que idProy está definido
            //const id = parseInt(idProy, 10);
            GetPeriodo().then((response)=>{
                if(response){
                    PeriodoAyudantia(response.idperiodo);
                    setReadyFechas(true);
                }
            })
            
        }
    }, [isAuthenticated, idProy]); 


    useEffect(()=>{
        if (isAuthenticated && idProy) { 
            fetchData(idProy);
            setReadySolicitudes(true);
        }
    }, [isAuthenticated, idProy, readySolicitudes])

    useEffect(()=>{
        if (isAuthenticated && idProy) { 
            verificarInformesPendientes();
            setReadyInformes(true);
        }
    }, [isAuthenticated, idProy])

    const fetchData = async (idProyecto: number) => {
        try {
          await ayudantiaService.ListSolicitudesAyudantiasByProyecto(token, idProyecto)
            .then((data) => {
              if (data.status.isSuccessfully) {
                setSolicitudes(data.listData);
              } else {
                setSolicitudes([]);
              }
            })
          //console.log(id)
        } catch (error) {
          console.error('Error:', error);
        }
      };

    const GetPeriodo = async () => {
        try {
            const response = await academicoService.GetPeriodoAcademicoEnEjecucion(token);
            setPeriodoActivo(response.data);
            return response.data; // Retorna el periodo
        } catch (error) {
            console.error(error);
            return VoidPeriodoAcademico(); // Manejo de errores
        }
    };

    const handleResponse = async (responseData: EstudianteActivoT) => {
        // Manejar la respuesta aquí
        setEstudiante(responseData);

        if (responseData.estudianteValido.length === 0) {
            setEstudianteValido(true);
            setLimpiar(true);
        }
    };

    const limpiarForm = () => {
        setEstudiante(VoidEstudianteActivo());
        setEstudianteValido(false);
        setLimpiar(false);
    };

    async function verificarInformesPendientes() {
        await proyectoService.InformesPendientesProyectosEnEjec( token )
            .then((data) => {
            //console.log(data.data);
            if (data.status.isSuccessfully) {
                setInformes(data.data);
            } else {
                setInformes(InitialInformesInvestigador());
            }
            })
            .catch((error) => {
            console.error(error)
            });
    }

    const handleResponseForm = async (responseData: SolicitudAyudanteInv) => {
        // Manejar la respuesta aquí
        if (responseData) {
            limpiarForm();
            alertaService.alertaExito("éxito", "Se ha registrado su solicitud de ayudante");
            setReadySolicitudes(false)
        }
    };

    const PeriodoAyudantia = async (idperiodo : number) => {
    try {
        
        await ayudantiaService.GetFechaAperturaCierreAyud(token,idperiodo)
        .then((data) => {
            if (data.status.isSuccessfully) {
            setFechasAyu(data.data);
            } else {
            setFechasAyu(VoidAyudPeriodo());
            }
        })
        .catch((error) => console.error(error));
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const datos: DataSolicitudAyudantiasProy = {
        rowsPerPage: [5, 10, 25, 100],
        data: solicitudes,
        periodoActivo: periodoActivo, 
        fechasAyudantias: fechasAyu,
        token: token,
        onActionEdit : handleSetReadySolicitudes
      };

    return (
        
        <Container maxWidth="lg" sx={{ padding: "20px" }}>
            <Paper elevation={3} sx={{ padding: "20px", borderRadius: "10px" }}>
                {/* Título Principal */}
                <Typography
                    variant="h4"
                    align="center"
                    gutterBottom
                    sx={{ color: "#243165", fontWeight: "bold", fontSize: "16px" }}
                >
                    AYUDANTÍAS INVESTIGACIÓN
                </Typography>

                {/* Botón de Proyectos */}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button onClick={()=> goToNavigation("/Proyectos")}
                        variant="contained"
                        sx={{
                            backgroundColor: "#243165",
                            color: "#FFFFFF !important",
                            "&:hover": { backgroundColor: "#1e284c" },
                            minWidth: "180px",
                            boxShadow: 3,
                        }}
                    >
                        PROYECTOS
                    </Button>
                </Box>

                
                {/* Tabs */}
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                    sx={{ marginY: 3 }}
                >
                    <Tab label="FORMULARIO" />
                    <Tab label="HISTÓRICO DE SOLICITUDES" />
                </Tabs>
                
                {tabIndex === 0 && (
                    <>
                    

                    {/* Mensaje informativo */}
                    {
                        readyFechas ?
                        <>
                        {/* Subtítulo */}
                        <Typography
                            variant="h6"
                            align="center"
                            gutterBottom
                            sx={{ color: "#243165", fontWeight: "bold", fontSize: "14px" }}
                        >
                            Solicitud para ayudantías de investigación {periodoActivo.termino + "-" + periodoActivo.anio}
                        </Typography>
                        <Alert severity="info" sx={{ marginBottom: 3 }}>
                            El período de solicitud de ayudantías de investigación inició {fechasAyu.fechaaperturaayudantias ? format(new Date(fechasAyu.fechaaperturaayudantias), 'dd/MMM/yyyy',{locale: es}) : "Fecha no disponible"} y finaliza {fechasAyu.fechacierreayudantias ? format(new Date(fechasAyu.fechacierreayudantias), 'dd/MMM/yyyy',{locale: es}) : "Fecha no disponible"}, fecha de Ecuador.
                        </Alert>
                        </>
                        
                        :
                        <PantallaCargaPage />
                    }
                    
                    {DentroPeriodoAyudantias() && readyFechas ?
                   
                        
                        readyInformes ?
                     

                        informes.pendiente ?
                            <>
                                <Typography variant="body1" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%' }}>
                                Se encontraron informes pendientes:
                                </Typography>
                                <TablaInformePendiente informe={informes} />
                            </>
                            :
                            <>
                                <EstudianteActivo token={token} tipo="I" ocultarBoton={limpiar} estudiante={estudiante} onResponse={handleResponse} onClean={limpiarForm}/>
                                <br />
                                {
                                    estudianteValido ?
                                    <SolicitarAyudForm token={token} estudiante={estudiante} idProyecto={idProy} onResponse={handleResponseForm} ayudantia={VoidAyudantiaInvestigacion()} periodoActivo={periodoActivo}/>
                                    : <></>
                                }
                            </> 
                            :
                            <></>
                        
                        :
                        <Alert severity="warning" > Nos encontramos fuera del periodo de solicitud de ayudantias de investigación</Alert>
                        // <PantallaCargaPage /> 
                    }
                    </>
                )}

                { tabIndex === 1 && (
                    <Box sx={{ mt: 4 }}>
                    <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
                      <Grid item xs={12}>
                        <Typography variant="h5" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: '#517ED3' }}>
                          Historial Solicitudes
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        {
                            readySolicitudes ?
                            <BusqProyAyudantiasTable  data={ datos }  />
                            :
                            <PantallaCargaPage />

                        }
                        
                      </Grid>
                    </Grid>
                  </Box>
                ) }
                

                
                
            </Paper>
        </Container>
        
    );
};
